"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RewardList = void 0;
var RewardList = /** @class */ (function (_super) {
    __extends(RewardList, _super);
    function RewardList() {
        var items = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            items[_i] = arguments[_i];
        }
        var _this = _super.apply(this, items) || this;
        _this.getNonHidden = function () { return new (RewardList.bind.apply(RewardList, __spreadArrays([void 0], _this.filter(function (x) { return !x.isHiddenFromList; }))))(); };
        /**
         *
         */
        _this.sortByFeatured = function () {
            if (_this.length > 0) {
                _this.sort(function (o1, o2) {
                    var fom1 = o1.featured_order_num;
                    var fom2 = o2.featured_order_num;
                    if (fom1 == null && fom2 == null) {
                        return (o2.date_start ? o2.date_start : 0) - (o1.date_start ? o1.date_start : 0);
                    }
                    else if (fom1 == null && fom2 != null) {
                        return 1;
                    }
                    else if (fom2 == null && fom1 != null) {
                        return -1;
                    }
                    return fom2 - fom1;
                });
            }
        };
        /**
         * Slice list into pages and return itmes on a specific page
         * @param itemsPerPage the total number of items per pages
         * @param page zero based index of the page to return. i.e. page >= 0
         */
        _this.getPage = function (itemsPerPage, page) {
            var result = new RewardList();
            var start = page * itemsPerPage;
            var end = start + itemsPerPage;
            if (_this.length > 0 && page >= 0 && start < _this.length) {
                var rewards = _this.slice(start, end);
                result = new (RewardList.bind.apply(RewardList, __spreadArrays([void 0], rewards)))();
            }
            return result;
        };
        /**
         * Get all featured rewards
         */
        _this.getFeatured = function () {
            var items = _this.filter(function (reward) { return reward.featured_order_num !== undefined && reward.featured_order_num !== null; });
            return new (RewardList.bind.apply(RewardList, __spreadArrays([void 0], items)))();
        };
        /**
         * Get all non featured rewards
         */
        _this.getNonFeatured = function () {
            var items = _this.filter(function (reward) { return !reward.featured_order_num && !reward.featured_order_num; });
            return new (RewardList.bind.apply(RewardList, __spreadArrays([void 0], items)))();
        };
        /**
         * Given a list of cateories, filter the catgories that have at least one reward in this list.
         *
         * @param categories
         */
        _this.filterCategories = function (categories) {
            var result = [];
            if (categories) {
                categories.forEach(function (item) {
                    if (_this.find(function (element) {
                        return element.category_id ? element.category_id.toString() === item.id.toString() : false;
                    })) {
                        result.push(item);
                    }
                });
            }
            return result;
        };
        /**
         * Given a list of cateories, filter the catgories that have at least one reward in this list.
         *
         * @param categories
         */
        _this.filterByCategory = function (category) {
            var result = new RewardList();
            if (category) {
                var filtered = _this.filter(function (element) {
                    return element.category_id ? element.category_id.toString() === category.id.toString() : false;
                });
                result = new (RewardList.bind.apply(RewardList, __spreadArrays([void 0], filtered)))();
            }
            return result;
        };
        return _this;
    }
    return RewardList;
}(Array));
exports.RewardList = RewardList;
//# sourceMappingURL=RewardList.js.map